
<template>
  <div v-if="mode">
    <h2 v-if="saveData.label" class="text-left">{{ saveData.label | token_replace(nid)}}</h2>
    <div class="text-left" v-html="token_replace(saveData.value, nid)"></div>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Paragraph'"
      @setting-click="showDialog = true"
      @menu-delete="$emit('menu-delete')"
      @collapse-click="collapsePreview"
    />
    <md-content v-show="!collapse">
      <h2 class="text-left">{{ saveData.label | token_replace(nid)}}</h2>
      <div class="text-left" v-html="token_replace(rendered, nid)"></div>
    </md-content>
    <md-dialog :md-active.sync="showDialog" @md-opened="initCKEditor" @md-closed="destroyCKEditor">
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <div class="ckeditor">
          <textarea :id="id"></textarea>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";

export default {
  name: "FbRichText",
  props: ["element", "uuid", "mode", "editor_format"],
  mixins: [FbElementMixin],
  mounted() {
    this.getRendered();
  },
  destroyed() {},
  computed: {
    id() {
      return "ckeditor" + this.uuid;
    },
  },
  data() {
    return {
      editorFormat: this.editor_format || "full_html",
      tempData: {
        label: this.element.data.label || "",
        value: this.element.data.value || ""
      },
      saveData: {
        label: this.element.data.label || "",
        value: this.element.data.value || ""
      },
      rendered: this.element.data.value || ""
    };
  },
  methods: {
    getRendered() {
      let html = document.createElement('div');
      html.innerHTML = this.saveData.value;
      let replacedText = [];
      if (html.innerHTML) {
        replacedText.push(
          this.getToken().then((token) => {
            let fetch_headers = new Headers();
            fetch_headers.append("Content-Type", "application/json");
            fetch_headers.append("X-CSRF-Token", token);
            return fetch("/api/v1/render-html", {
              credentials: "include",
              method: "POST",
              headers: fetch_headers,
              dataType: "json",
              body: JSON.stringify({
                text: html.innerHTML,
                format: this.editorFormat,
              }),
            });
          }).then((data) => {
            return data.text();
          }).then((text) => {
            return html.innerHTML = text;
          })
        );
        return Promise.all(replacedText).then(() => {
          this.rendered = html.innerHTML;
        });
      }
      return this.saveData.value;
    },
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include"
      })
        .then(response => {
          return response.text();
        })
        .then(text => {
          return text;
        });
    },
    getCKEditorElementId(element) {
      return element.getAttribute('data-ckeditor5-id');
    },
    save() {
      this.showDialog = false;
      const ckeditorId = this.id;
      if (Drupal.editors.ckeditor5) {
        let id = this.getCKEditorElementId(document.getElementById(ckeditorId));
        const editor = Drupal.CKEditor5Instances.get(id);
        debugger
        let ckeditorData = editor.getData();
        this.tempData.value = ckeditorData;
        this.saveData = JSON.parse(JSON.stringify(this.tempData));
        this.getRendered();
        this.$emit("save-data", { data: this.saveData, list: [] });
        return;
      }
      let ckeditorData = window.CKEDITOR.instances[ckeditorId].getData();
      this.tempData.value = ckeditorData;
      this.saveData = JSON.parse(JSON.stringify(this.tempData));
      this.getRendered();
      this.$emit("save-data", { data: this.saveData, list: [] });
    },
    initCKEditor() {
      const ckeditorId = this.id;
      if (Drupal.editors.ckeditor5) {
        const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
            if (mutation.attributeName === 'data-ckeditor5-id') {
              var waitForEditor = setInterval((ckeditor5Id, textArea) => {
                const editor = Drupal.CKEditor5Instances.get(ckeditor5Id);
                if (editor) {

                  editor.setData(this.tempData.value);

                  clearInterval(waitForEditor);
                  observer.disconnect();
                }
              }, 50, mutation.target.dataset.ckeditor5Id, mutation.target);
            }
          });
        });
        observer.observe(document.getElementById(ckeditorId), {attributes: true});
        Drupal.editors.ckeditor5.attach(document.getElementById(ckeditorId), window.drupalSettings.editor.formats[this.editorFormat]);
        return;
      }
      const _loadExternalPlugins = function _loadExternalPlugins(format) {
        var externalPlugins = format.editorSettings.drupalExternalPlugins;
        format.editorSettings.drupal = {
          format: format.format
        };
        if (externalPlugins) {
          Object.keys(externalPlugins || {}).forEach(function(pluginName) {
            window.CKEDITOR.plugins.addExternal(
              pluginName,
              externalPlugins[pluginName],
              ""
            );
          });
          delete format.editorSettings.drupalExternalPlugins;
        }
      };
      //config from Back
      if (
        typeof window.drupalSettings != "undefined" &&
        typeof CKEDITOR != "undefined"
      ) {
        const ckeditorConfig = window.drupalSettings.editor.formats[this.editorFormat].editorSettings;
        _loadExternalPlugins(window.drupalSettings.editor.formats[this.editorFormat]);
        window.CKEDITOR.replace(ckeditorId, ckeditorConfig);
        window.CKEDITOR.instances[ckeditorId].setData(this.tempData.value);
      }
    },
    destroyCKEditor() {
      const ckeditorId = this.id;
      if (Drupal.editors.ckeditor5) {
        Drupal.editors.ckeditor5.detach(document.getElementById(ckeditorId), window.drupalSettings.editor.formats[this.editorFormat]);
        return;
      }
      if (window.CKEDITOR.instances[ckeditorId]) {
        window.CKEDITOR.instances[ckeditorId].destroy();
      }
    }
  }
};
</script>

<style>
.md-dialog .md-dialog-container {
  max-width: 100%;
}
.md-dialog .ck.ck-content {
  min-height: 200px;
  max-height: 300px;
}
</style>

<style scoped>
.md-dialog {
  min-width: 70%;
  @media all and (max-width: $breakpoint-medium) {
    min-width: 90%;
  }
}
.text-left {
  text-align: left;
}
.md-dialog-content::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
}
.md-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
